<template>
  <div class="">
    <el-card
      class="settings"
      shadow="never">
      <div
        slot="header"
        class="settings-header">服务机构组件<el-button
          type="danger"
          style="margin-left: 8px;"
          @click="deleteitem">删除</el-button></div>
      <!-- <el-form
        ref="series"
        :model="series"
        label-width="100px">
        <el-form-item
          label=""
          label-width="0">
          <el-button
            type="primary"
            style="margin-bottom: 10px;"
            @click="addGoods">选择机构</el-button>
          <el-table
            border
            :data="series.graphics">
            <el-table-column
              label="机构名称"
              min-width="180"
              prop="servOrgName"> </el-table-column>
            <el-table-column
              label="操作"
              width="80"
              prop="vendorAddress">
              <template slot-scope="{ row, $index }">
                <el-button
                  type="text"
                  @click="deleteRow($index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form> -->
      <org-top-list />
      <!-- <we-service-org-select-modal
        ref="vendor"
        @select="handleSelect" /> -->
    </el-card>
  </div>
</template>
<script>
import OrgTopList from '../list-top-flag/org-top-list.vue'
// import WeServiceOrgSelectModal from './we-service-org-select-modal.vue'
export default {
  name: 'WeServiceOrg',
  components: { OrgTopList },
  props: {
    value: {
      type: Object,
      default() {
        return { componentName: 'servorgshow', graphics: [], layoutType: 2, visible: false }
      }
    },
    index: Number
  },
  computed: {
    series: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    }
  },
  methods: {
    deleteitem() {
      this.$emit('deleteItem', this.index)
    },
    // deleteRow($index) {
    //   this.series.graphics.splice($index, 1)
    // },
    // addGoods() {
    //   const selection = this.series.graphics.map(i => i.id)
    //   this.$refs.vendor.fetch(selection)
    // },
    // handleSelect(row) {
    //   console.log(this.series)
    //   this.$message.success('添加成功')
    //   this.series.graphics.push(row)
    // },
    submit() {
      return Promise.resolve()
      // return new Promise((resolve, reject) => {
      //   const graphics = this.series.graphics
      //   if (graphics.length === 0) {
      //     this.$message.error('请选择服务')
      //     reject(new Error(JSON.stringify({ index: this.index })))
      //   } else {
      //     resolve()
      //   }
      // })
    }
  }
}
</script>
